import { ProductBundleDetailsPageHitV1 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const PRODUCT_BUNDLE_DETAILS_PAGE_HIT = ({ data }: { data?: unknown }) => {
	const payload = data as {
		universe?: string;
		productGroupId?: number;
	};

	return buildEvent({
		Event: ProductBundleDetailsPageHitV1,
		payload: {
			universe: normalizeUniverse(payload?.universe),
			productGroupId: Number(payload?.productGroupId),
		},
	});
};
